import { SessionStorage } from "./sessionStorage";

class CurrentRoomChatIdStorage extends SessionStorage {
	public constructor() {
		super({
			storageKey: "current_room_chat_id",
		});
	}
}

export const currentRoomChatIdStorage = new CurrentRoomChatIdStorage();
